const showSpinnerSuccess = (data) => ({
  type: 'SHOW_SPINNER_SUCCESS',
  data
});

export const mutation = {
  showSpinnerSuccess
};
